import { Injector, NgModule } from '@angular/core';
import { DeliveryDateFacade, DeliverySlotsFacade } from '@delivery/data-access';
import { EffectsModule } from '@ngrx/effects';
import { MODULE_INITIALIZER } from '@spartacus/core';
import { effects } from './effects';
import { DeliveryDateService } from './services';
import { DeliverySlotsService } from './services/delivery-slots.service';
import { DeliveryZonesLazyService } from './services/delivery-zones-lazy.service';
import { DeliveryZonesService } from './services/delivery-zones.service';

function initDeliveryZonesFactory(injector: Injector): () => void {
  return () => {
    const deliveryZonesService = injector.get(DeliveryZonesService);

    deliveryZonesService.init();
  };
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    {
      provide: DeliverySlotsService,
      useExisting: DeliverySlotsFacade,
    },
    {
      provide: DeliveryDateService,
      useExisting: DeliveryDateFacade,
    },
    DeliveryZonesLazyService,
    {
      provide: DeliveryZonesService,
      useExisting: DeliveryZonesLazyService,
    },
    {
      provide: MODULE_INITIALIZER,
      useFactory: initDeliveryZonesFactory,
      deps: [Injector],
      multi: true,
    },
  ],
})
export class DeliveryFeatureModule {}
